import React, { useContext } from 'react'
import './index.scss'
import { observer } from 'mobx-react'
import ConfigurationMFA from '@Scenes/UserRegistrationScenes/CreatePasswordScene/ConfigurationMFA'
import { CreatePasswordStatus } from '@App/enum/create-password-status'
import ConfirmSMSCode from '@Scenes/UserRegistrationScenes/CreatePasswordScene/ConfirmSMSCode'
import { StoresContext } from '@App/contexts'
import { NavLink, useLocation } from 'react-router'

const EnrollMFAScene = () => {
    const { createPasswordStore } = useContext(StoresContext)
    const path = useLocation()
    const isMfaReset = path.pathname === '/enroll-mfa'

    const getComponent = () => {
        switch (createPasswordStore.createPasswordStatus) {
            case CreatePasswordStatus.confirm_sms_code:
                return <ConfirmSMSCode loading={false} setLoading={() => {}} />
            case CreatePasswordStatus.config_done:
                return !isMfaReset ? (
                    <div className="global-container">
                        <div className="after-mfa-confirmed">
                            <h3>Password set!</h3>
                            <p>Your personal user account password has been set successfully.</p>
                            <NavLink to="/login">Go to Portal</NavLink>
                        </div>
                    </div>
                ) : (
                    <div className="global-container">
                        <div className="after-mfa-confirmed">
                            <h3>MFA Settings Updated</h3>
                            <p>
                                You will now need to login to The MLC Portal using your new MFA type by clicking the
                                link below.
                            </p>
                            <NavLink to="/login">Go to Portal</NavLink>
                        </div>
                    </div>
                )
            default:
                return <ConfigurationMFA loading={false} setLoading={() => {}} isLoggingIn />
        }
    }
    return <div className="enroll-mfa-scene">{getComponent()}</div>
}

export default observer(EnrollMFAScene)
